import React from 'react'
import SendMsgForm from '../../components/Form/SendMsgForm'
import ScrollToTop from '../../utils/ScrollToTop'
import './Contact.css'

const Contact = () => {
    ScrollToTop()
    return (
        <div className="contact">
            <div id="container" className="contact-flex">
                <div className="flex-col contact-text">
                    <p className="subhead">You have something in mind ?</p>
                    <h1>Contact me</h1>
                    <p>If you have some project to do or are looking for more information regarding Frontend web developement or Graphic design, Feel free to contact me.</p>
                </div>
                <div className="flex-col form">
                    <SendMsgForm />
                </div>
            </div>
        </div>
    )
}

export default Contact
